(function() {
    'use strict';

    angular.module('vhols')

        .service('messageService', ["$window", function($window) {
            var service = {
                message: message
            };

            function message(message) {
                $window.postMessage(message, $window.location.protocol + '//' +  $window.location.host);
            }

            return service;
        }]);
})();
